module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAELSURBVChTY2BxsP7HYmi2kwEIWMwsz7DYW/9l5ObTAvFhgInxD+MrBn5mNxZd47V/b9xIZ2D8z8hsqnOFkYNLFqoGAlisbB6xOFj+Z9EzXgPmO1j9A2FGXgF9EJ8RRIAAi7XNUwbWv1IMb3+u/HP5XARIEUj677lrpnBFIMBiaXOHgf2vMsPrH0v+XLuYxGJv8RMkzgSWhQFGBjYw/e/fdwYWVn4wGwjgJrHa2r76z/xHlOHF1xl/bl7JA5vyn/H/3zOXdSEKbGyegx2ubbgYxIc7nJNbEcRnZLW1ef2f+a8IyB1/nz6awWygfhhkwZ+jZ8QYfv98A1IE0aVrtBLEBpr4DGwCShgxMAAAdGlacWHi7K4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/default/rigth_arrow1.png
// module id = v70D
// module chunks = 1